import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorIcon from '@mui/icons-material/Error';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import GradeIcon from '@mui/icons-material/Grade';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import ScheduleIcon from '@mui/icons-material/Schedule';
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";

interface AccordionProps {
  title: string;
  id?: string;
  children?: any;
  variant?:
      'level1' | 'level2' | 'level3' | 'level4' | 'accounting' | 'logistics' | 'packaging' | 'purchase' | 'sales';
  sx?: any;
  headerSize?: 'small' | 'large';
  expandIcon?: any;
  expandIconPos?: 'left' | 'right';
  statusIndication?: 'ok' | 'warn' | 'error' | 'automate' | 'new' | 'renew' | 'star' | 'file' | 'schedule' | 'delete';
  onStatusClick?: Function,
  onStatusParams?: any[];
  customHeaderEntry?: any;
  ariaControls?: string;
  disabled?: boolean;
}

const FaAccordion = (props: AccordionProps) => {

  const {
    title,
    id,
    children,
    variant,
    sx,
    expandIcon,
    expandIconPos,
    statusIndication,
    onStatusClick,
    onStatusParams,
    customHeaderEntry,
    ariaControls,
    disabled,
  } = props;

  const size = props.headerSize ?? 'small';
  const iconSize = props.headerSize === 'large' ? "medium" : "small";

  const flexDir = (expandIconPos === 'left')
      ? {flexDirection: 'row-reverse'}
      : {flexDirection: 'row'};

  const sxHeader = (size === 'large')
      ? {paddingTop: '.5rem', paddingBottom: '.4rem'}
      : {paddingTop: '0', paddingBottom: '0'};

  const onNoPropClick = (e: any) => {
    e.stopPropagation();
    if (onStatusClick)
      onStatusClick.call(this, onStatusParams);
  };

  const buttonWrap = (el: any, label?: string) => {
    return (
        <IconButton onClick={onNoPropClick} color={'primary'}
                    sx={{margin: '-12px -8px 0 0', transform: "translateY(5px)"}}
                    aria-label={label}
        >
          {el}
        </IconButton>
    );
  };

  const icons = {
    ok: <CheckCircleOutlineIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>,
    warn: <ReportProblemIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'warning'}/>,
    error: <ErrorIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'error'}/>,
    automate: <SettingsSuggestIcon color={onStatusClick ? 'secondary' : 'primary'}/>,
    new: <FiberNewIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'success'}/>,
    renew: <AutorenewIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>,
    star: <GradeIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>,
    file: <FilePresentIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>,
    schedule: <ScheduleIcon fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>,
    delete: <Delete fontSize={iconSize} color={onStatusClick ? 'secondary' : 'primary'}/>
  }

  return (
      <Accordion sx={{sx}} disabled={disabled ?? false}>
        <AccordionSummary
            id={id ?? ''}
            variant={variant ?? 'level1'}
            expandIcon={expandIcon ?? <ExpandMoreIcon/>}
            sx={{...flexDir, ...sxHeader}}
            aria-controls={ariaControls ?? 'accordion-summary-content'}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <Typography variant={size === 'large' ? 'h4' : 'h5'} dangerouslySetInnerHTML={{__html: title}}
                          sx={{width: 'auto'}}></Typography>
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign: 'right', paddingRight: '1rem'}}>
              {customHeaderEntry}
              {statusIndication && (onStatusClick ? buttonWrap(icons[statusIndication], statusIndication) : icons[statusIndication])}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {children}
        </AccordionDetails>
      </Accordion>
  )
}

export default FaAccordion;
